export function getPdfServerUrl(): string {
  const configured = process.env.REACT_APP_PDF_SERVER_URL?.trim();
  if (configured) return configured.replace(/\/+$/, "");

  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  }

  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }

  return "";
}
